import { API } from 'aws-amplify';

import { RnrsData } from '../components/rnrs/RnrsBulkUploadPreview';

export function getAllRnrs(lastEvaluatedKeyData) {
  const query = lastEvaluatedKeyData
    ? `?productId=${lastEvaluatedKeyData.productId}&userId=${lastEvaluatedKeyData.userId}`
    : '';
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', `/reviews${query}`);
}

export function createReviewResponse(productId, userId, response) {
  return API.post('party', `/reviews/${productId}/${userId}/response`, {
    body: response,
  });
}

export function updateReviewResponse(productId, userId, response) {
  return API.patch('party', `/reviews/${productId}/${userId}/response`, {
    body: response,
  });
}

export function deleteReviewResponse(productId, userId) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.del('party', `/reviews/${productId}/${userId}/response`);
}

export function changeReviewVisibility(productId, userId, hidden) {
  return API.put('party', `/reviews/${productId}/${userId}/visibility`, {
    body: {
      hidden,
    },
  });
}

export function updateRnRFeaturedStatus(item) {
  return API.patch('party', `/reviews/${item.productId}`, {
    body: {
      userId: item.userId,
      featured: !item.featured,
    },
  });
}

export function batchCreateRnrs(data: RnrsData) {
  return API.post('party', '/reviews/external', { body: data });
}
